import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { firestoreService } from '../../services/firestoreService';
import { FaHeart, FaLock, FaPaperPlane } from 'react-icons/fa6';

const OrderSongPage = () => {
  const { user } = useAuth();
  const location = useLocation();

  const [name, setName] = useState('');
  const [email, setEmail] = useState(user?.email || '');
  const [story, setStory] = useState(location.state?.prompt || '');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  if (!user) {
    return (
      <div className="order-song-page">
        <div className="container">
          <div className="access-gate">
            <div className="access-gate-icon"><FaLock /></div>
            <div className="access-gate-title">Login Required</div>
            <div className="access-gate-text">
              Sign in or create an account to start a personalized song.
            </div>
            <div className="access-gate-actions">
              <Link to="/login" className="btn btn-primary">Login</Link>
              <Link to="/signup" className="btn btn-outline">Sign Up</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim() || !email.trim() || !story.trim()) {
      setError('Please fill in your name, email, and story before submitting.');
      return;
    }

    setSubmitting(true);
    const result = await firestoreService.createSongOrder({
      name: name.trim(),
      email: email.trim(),
      story: story.trim(),
      userId: user.uid,
    });
    setSubmitting(false);

    if (result.success) {
      setSubmitted(true);
    } else {
      setError('We could not submit your request right now. Please try again shortly.');
    }
  };

  if (submitted) {
    return (
      <div className="order-song-page">
        <div className="container">
          <div className="contact-success">
            <FaHeart size={40} color="var(--secondary-color)" />
            <h1>Request Received</h1>
            <p>
              Thank you! We've received your story. Our team will reach out by email
              with next steps for your personalized song.
            </p>
            <Link to="/media" className="btn btn-primary">Back to Media</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="order-song-page">
      <div className="container">
        <div className="order-song-header">
          <FaHeart size={40} color="var(--primary-color)" />
          <h1>Start Your Song</h1>
          <p>
            Tell us a little about you and your story. This begins your secure,
            personalized-song order — no payment is taken yet.
          </p>
        </div>

        <form className="order-song-form" onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="name" className="form-label">Your Name</label>
            <input
              id="name"
              type="text"
              className="form-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Jane Doe"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              id="email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="story" className="form-label">Your Story</label>
            <textarea
              id="story"
              className="form-input"
              rows={6}
              value={story}
              onChange={(e) => setStory(e.target.value)}
              placeholder="Share the story, memory, or occasion you'd like your song to capture..."
            />
          </div>

          <button type="submit" className="btn btn-primary btn-large w-full" disabled={submitting}>
            {submitting ? (
              <>
                <div className="spinner"></div>
                Submitting...
              </>
            ) : (
              <>
                <FaPaperPlane /> Submit My Story
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default OrderSongPage;
